import { Button, Input, Modal } from "antd";
import styles from "./EditItemDetails.module.css";
import { useEffect, useRef } from "react";

const OfferDetailsADialog = ({
  taansOpen,
  setTaansOpen,
  taansData,
  setTaansData,
  handleTaansBillSave,
  offerARate,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setTaansOpen(false);
    setTaansData([]);
  };
  useEffect(() => {
    if (taansOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [taansOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#114a3d",
            borderRadius: "8px",
            padding: "4px 8px",
            color: "white",
          }}
        >
          Product Details
        </strong>
      }
      open={taansOpen}
      closable={false}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <div className={styles.cardContainer2}>
        <div className={styles.infoBox2}>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Design Code</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "18px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                  fontWeight: "bold",
                }}
                disabled
                value={taansData[0]?.DesignCode}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Product Name</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={taansData[0]?.ProdName}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Qty</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Qty"
                ref={inputRef}
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                value={taansData[0]?.stock ?? 0}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  const input = e.target.value;

                  // allow numbers with up to 2 decimal places
                  if (!/^\d*\.?\d{0,2}$/.test(input)) return;

                  const qty = Number(input);
                  const maxQty = 3;

                  // stop if qty exceeds max
                  if (qty > maxQty) return;

                  const rate = Number(offerARate) || 0;

                  // handle qty logic
                  const finalQty = qty;
                  const oQty =
                    qty === 2 ? taansData[0]?.OQTY2 : taansData[0]?.OQTY3;

                  // prevent divide by zero
                  const rateValue = finalQty > 0 ? (oQty || 0) / finalQty : 0;

                  const price = qty === 1 ? rate : rateValue;

                  setTaansData((prev) =>
                    prev.map((item) =>
                      item.DesignCode === taansData[0]?.DesignCode
                        ? {
                            ...item,
                            stock: qty,
                            CPrice: price,
                            offer: price,
                          }
                        : item
                    )
                  );
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, saveRef);
                }}
              />
              {/* <Input
                placeholder="Enter Qty"
                ref={inputRef}
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                value={taansData[0]?.stock ?? 0}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  const val = e.target.value;

                  // Allow only numbers
                  if (!/^\d*$/.test(val)) return;

                  const updatedValue = val === "" ? "" : Number(val);

                  const maxQty = taansData[0]?.Qty ?? 0;

                  // Do not allow over-edit
                  if (updatedValue !== "" && updatedValue > maxQty) return;

                  setTaansData((prev) =>
                    prev.map((item) =>
                      item.DesignCode === taansData[0]?.DesignCode
                        ? { ...item, stock: updatedValue || 0 }
                        : item
                    )
                  );
                }}
                onKeyDown={(e) => handleKeyDown(e, rateRef)}
              /> */}
            </span>
          </div>

          {/* WASTAGE */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Rate"
                style={{ width: "200px", height: 32, fontSize: "16px" }}
                disabled
                ref={rateRef}
                value={taansData[0]?.CPrice ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const disPer = taansData[0]?.Disper;
                    const rateValue = val * Number(disPer);
                    const disAmt = Number(rateValue) / 100;
                    const ActRate = taansData[0]?.stock * val;

                    setTaansData((prev) =>
                      prev.map((item) =>
                        item.DesignCode === taansData[0]?.DesignCode
                          ? {
                              ...item,
                              CPrice: val,
                              Disamt: 0,
                              offer: ActRate,
                            }
                          : item
                      )
                    );
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disPerRef);
                }}
              />
            </span>
          </div>

          {/* DIRECTWT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Per(%)</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Per"
                disabled
                style={{ width: "200px", height: 32, fontSize: "16px" }}
                ref={disPerRef}
                value={taansData[0]?.Disper ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (!/^\d*\.?\d*$/.test(val)) return;
                  const rate = taansData[0]?.CPrice;
                  const rateValue = rate * val;
                  const disAmt = rateValue / 100;
                  const ActRate = rate - disAmt;

                  setTaansData((prev) =>
                    prev.map((item) =>
                      item.DesignCode === taansData[0]?.DesignCode
                        ? {
                            ...item,
                            Disper: val,
                            Disamt: 0,
                            offer: ActRate,
                          }
                        : item
                    )
                  );
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disAmtRef);
                }}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Amt</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Amt"
                style={{ width: "200px", height: 32, fontSize: "16px" }}
                disabled
                ref={disAmtRef}
                value={taansData[0]?.Disamt ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    //   const updatedValue = val === 0 ? 0 : Number(val);
                    const rate = taansData[0]?.CPrice;
                    const ActRate = rate - val;

                    setTaansData((prev) =>
                      prev.map((item) =>
                        item.DesignCode === taansData[0]?.DesignCode
                          ? { ...item, Disamt: val, offer: ActRate }
                          : item
                      )
                    );
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, saveRef);
                }}
              />
            </span>
          </div>

          {/* TOTALWT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Act Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={Number(taansData[0]?.offer)?.toFixed(2) || 0}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Amount</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={
                  Number(taansData[0]?.stock * taansData[0]?.offer)?.toFixed(
                    2
                  ) || 0
                }
              />
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "right",
          marginTop: 10,
          display: "flex",
          justifyContent: "right",
          gap: "10px",
        }}
      >
        <Button
          onClick={() => {
            handelCancel();
          }}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #BF092F",
            color: "#BF092F",
            borderRadius: "8px",
            width: 100,
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          ref={saveRef}
          onClick={() => {
            handleTaansBillSave();
          }}
          style={{
            width: 100,
            backgroundColor: "#006400",
            borderRadius: "8px",
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default OfferDetailsADialog;
